module.exports = __webpack_public_path__ + "img/razzo.f8abca60.webp";